import { createFileRoute } from '@tanstack/react-router'
import { FreeSWITCHApplyPage } from '@/features/freeswitch'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/freeswitch/apply/')({
  component: FreeSWITCHApplyPage,
  beforeLoad: requireRole(['admin']),
})
